// extracted by mini-css-extract-plugin
module.exports = {"headline":"home-module--headline--3LdpI","fullBgImage":"home-module--full-bg-image--2a29c","overlay":"home-module--overlay--3BAAO"};